import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  SelectChangeEvent,
} from '@mui/material';
import './Form.css';

const Form: React.FC = () => {
  const countryList = [
    'Romania',
    'Moldova',
    'Germany',
    'France',
    'Italy',
    'Spain',
    'United Kingdom',
    'United States',
    'Canada',
    'Australia',
  ];

  const [country, setCountry] = useState('');

  const handleCountryChange = (event: SelectChangeEvent<string>) => {
    setCountry(event.target.value);
  };

  return (
    <Grid container spacing={4} mt={5} ml={7} mb={5} className="helllooo">
      <Grid item xs={12} sm={12} md={6} id="form-block">
        <Typography sx={{ color: '#ffffff', fontSize: '24px', fontWeight: 600 }}>
          Contact Us
        </Typography>
        <Typography sx={{ color: '#ffffff', fontSize: '14px', mb: 2, ml: 1 }}>
          Have a question for us? Please fill out the form below and we’ll be in touch soon.
        </Typography>

        <Box className="gap-manual">
          <TextField
            className="form-block"
            variant="outlined"
            fullWidth
            placeholder="First Name"
            margin="normal"
            InputProps={{
                classes: {
                input: 'input',   
                }
            }}

          />
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Last Name"
            className="input"
            margin="normal"
            InputProps={{
                classes: {
                input: 'input',   
                }
            }}

          />
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Mobile"
            className="input"
            margin="normal"
            InputProps={{
                classes: {
                input: 'input',  
                }
            }}

          />

            <FormControl fullWidth margin="normal">
            <InputLabel sx={{ color: '#909090' }}>Country</InputLabel>
            <Select
                value={country}
                onChange={handleCountryChange}
                displayEmpty
                sx={{ color: '#ffffff' }}
                inputProps={{ 'aria-label': 'Country' }}
            >
                <MenuItem value="">
                </MenuItem>
                {countryList.map((countryItem) => (
                <MenuItem key={countryItem} value={countryItem}>
                    {countryItem}
                </MenuItem>
                ))}
            </Select>
            </FormControl>

          <TextField
            variant="outlined"
            fullWidth
            placeholder="Message"
            className="input"
            margin="normal"
            multiline
            rows={4}
            InputProps={{
                classes: {
                input: 'input', 
                }
            }}

          />

          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: '#ffffff', color: '#000' }}
          >
            Submit
          </Button>
        </Box>
      </Grid>
       
      <Grid item xs={12} sm={12} md={6} >
        <Typography sx={{ color: '#ffffff', fontSize: '24px', fontWeight: 600 }}>
          8Rabbits Ltd
        </Typography>
        <Typography sx={{ color: '#ffffff', fontSize: '14px', mb: 2, ml: 1 }}>
          General info about us and our company.
        </Typography>
        <Typography sx={{ color: '#ffffff', fontSize: '16px', fontWeight: 600 }}>
          Office address
        </Typography>
        <Typography sx={{ color: '#ffffff', fontSize: '14px', mb: 2, ml: 1 }}>
          Israel ...
        </Typography>
        <Typography sx={{ color: '#ffffff', fontSize: '16px', fontWeight: 600 }}>
          Phone
        </Typography>
        <Typography sx={{ color: '#ffffff', fontSize: '14px', mb: 2, ml: 1 }}>
          📞 +000 8888888
        </Typography>
    </Grid>
    </Grid>
  );
};

export default Form;
